import { Injectable } from '@angular/core';

// rxjs
import { Observable } from 'rxjs';

import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

// other services
import { TranslateService } from "@ngx-translate/core";

// config
import { environment } from "../../environments/environment";

@Injectable({
    providedIn: 'root'
})

export class CredentialService {

    /**
     * constructor
     *
     * @param http
     */
    constructor(
        private http: HttpClient,
        private translate: TranslateService
    ) { }

    /**
     * get credential by token
     *
     * @param {string} token
     *
     * @return {Observable<any>}
     */
    public getById(token: string): Observable<any> {

        let headers = new HttpHeaders();

        if (environment.sameSiteAssets) {
            headers = headers.append("Accessing-From", window.location.hostname);
        }

        let params = new HttpParams();
        params = params.append('forceLocale', this.translate.currentLang);


        return this.http.get(environment.api + '/credentials/' + token, { headers: headers, params: params });
    }

    /**
     * get list of participant credentials
     *
     * @param {number} participantId
     *
     * @return {Observable<any>}
     */
    public getParticipantCredentials(participantId: number): Observable<any> {
        return this.http.get(environment.api + '/participant/' + participantId + '/credentials');
    }

    /**
     * get list of participant credentials by token
     *
     * @param {string} token
     *
     * @return {Observable<any>}
     */
    public getParticipantCredentialsByToken(token: string): Observable<any> {

        let headers = new HttpHeaders();

        if (environment.sameSiteAssets) {
            headers = headers.append("Accessing-From", window.location.hostname);
        }

        let params = new HttpParams();
        params = params.append('forceLocale', this.translate.currentLang);

        return this.http.get(environment.api + '/credentials/by-token/' + token, { headers: headers, params: params });
    }

    /**
     * get verification token for sharing credential wallet
     *
     * @param {number} participantId
     * @param {Array<number>} selected
     *
     * @return {Observable<any>}
     */
    public getParticipantCredentialsToken(participantId: number, selected: Array<number>): Observable<any> {
        return this.http.post(environment.api + '/participant/' + participantId + '/credentials/token', {
            selected: selected
        });
    }
}
